var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-banner text-center"},[_c('h2',[_c('strong',[_vm._v("Welcome to STEM Day Admin Tool")])])])])
}]

export { render, staticRenderFns }